import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getGoldenDomeDataByApp = {
  name: "getGoldenDomeDataByApp" as const,
  input: z.null(),
  output: z.array(
    z.object({
      appId: zExt.objectId(),
      appTitle: z.string(),
      teams: z.array(
        z.object({
          teamId: zExt.objectId(),
          teamName: z.string(),
          storeUrl: z.string(),
          installedAt: z.string().nullable(),
        }),
      ),
    }),
  ),
};
